import { DanceManagerUserInviteRequestInterface, DanceManagerUserInviteTokenExpirationTimeEnum, DanceManagerUserRoleEnum } from '../../..';

export class DanceManagerUserInviteRequestDto implements DanceManagerUserInviteRequestInterface{
  role: DanceManagerUserRoleEnum;
  email?: string;
  expirationTime? = DanceManagerUserInviteTokenExpirationTimeEnum.TWO_WEEKS;
}
